import {
  createSlice,
  PayloadAction,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit'
import { initialState } from '../initialState/advisorWebsocket'

const advisorWebsocketSlice = createSlice({
  name: 'advisorWebsocket',
  initialState,
  reducers: {
    setConnectionStatus(state, action: PayloadAction<boolean>) {
      state.isConnected = action.payload
    },
    setWebSocketError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<typeof initialState>) => {
    builder
      .addCase('websocket/connectAdvisor/fulfilled', (state) => {
        state.isConnected = true
        state.error = null
      })
      .addCase('websocket/connectAdvisor/rejected', (state, action: any) => {
        state.isConnected = false
        state.error = action.error?.message || 'WebSocket connection failed'
      })
      .addCase(
        'websocket/sendAdvisorMessage/rejected',
        (state, action: any) => {
          state.error = action.error?.message || 'WebSocket send message failed'
        }
      )
  },
})

export const { setConnectionStatus, setWebSocketError } =
  advisorWebsocketSlice.actions
export default advisorWebsocketSlice.reducer
